import React from 'react';
import PropTypes from 'prop-types';
import { css, cx } from 'linaria';
const modalHeaderStyles = "m1oixje6";
export const ModalHeader = ({
  title,
  hasBorder,
  isSticky,
  className
}) => {
  return <h6 data-cy="modal-header" className={cx(modalHeaderStyles, hasBorder && 'bordered', isSticky && 'sticky', className)}>
      {title}
    </h6>;
};
ModalHeader.propTypes = {
  title: PropTypes.string.isRequired,
  hasBorder: PropTypes.bool,
  isSticky: PropTypes.bool
};
ModalHeader.defaultProps = {
  hasBorder: true,
  isSticky: true
};
export default ModalHeader;

require("./modal-header.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./modal-header.js");